<template>
    <v-dialog v-model="dialog" max-width="1000" scrollable @click:outside="closeDialog">
        <v-card>
            <v-card-title>
                {{ machineData.name }}
                <v-spacer />
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
                <template v-if="configurationLoading">
                    <div class="pa-10 text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="64"
                        />
                        <p class="mt-4 grey--text">
                            Ładowanie konfiguracji...
                        </p>
                    </div>
                </template>
                <template v-else-if="hasEfficiencyTabs">
                    <v-tabs v-model="tab">
                        <v-tab v-if="machineData.efficiencyTypeId === 1">
                            Konfiguracja wydajności dla papierów
                        </v-tab>
                        <v-tab v-if="machineData.efficiencyTypeId === 2">
                            Konfiguracja wydajności dla druku cyfrowego (arkusz)
                        </v-tab>
                        <v-tab v-if="machineData.efficiencyTypeId === appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId">
                            Konfiguracja wydajności cięcia z rolki
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-if="machineData.efficiencyTypeId === 1">
                            <div class="pa-5">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-data-table
                                                :headers="headers"
                                                :items="configurationPapers"
                                                :mobile-breakpoint="0"
                                                :items-per-page="-1"
                                                item-key="uniqueKey"
                                                hide-default-footer
                                            >
                                                <template #item.paperGroupId="{item}">
                                                    <v-select
                                                        v-model="item.paperGroupId"
                                                        :items="paperGroups"
                                                        item-value="id"
                                                        item-text="name"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.papertWeightBegin="{item}">
                                                    <v-text-field
                                                        v-model.number="item.papertWeightBegin"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.papertWeightEnd="{item}">
                                                    <v-text-field
                                                        v-model.number="item.papertWeightEnd"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.amountPerHour="{item}">
                                                    <v-text-field
                                                        v-model.number="item.amountPerHour"
                                                        v-mask="'######'"
                                                        type="number"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.actions="{item}">
                                                    <v-btn
                                                        icon
                                                        color="error"
                                                        data-sentry-label="Usuń"
                                                        @click="removeRow(item)"
                                                    >
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <template #no-data>
                                                    <div class="text-center py-5 grey--text">
                                                        Brak danych. Dodaj konfigurację klikając przycisk poniżej.
                                                    </div>
                                                </template>
                                                <template #footer>
                                                    <div class="pa-3">
                                                        <v-btn
                                                            color="secondary"
                                                            small
                                                            data-sentry-label="Dodaj kolejną konfigurację dla papieru"
                                                            @click="addNewRow"
                                                        >
                                                            <v-icon left small>
                                                                mdi-plus
                                                            </v-icon>
                                                            Dodaj kolejną konfigurację
                                                        </v-btn>
                                                    </div>
                                                </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-tab-item>
                        <v-tab-item v-if="machineData.efficiencyTypeId === 2">
                            <div class="pa-5">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-data-table
                                                :headers="digitalHeaders"
                                                :items="configurationDigital"
                                                :mobile-breakpoint="0"
                                                :items-per-page="-1"
                                                item-key="uniqueKey"
                                                hide-default-footer
                                            >
                                                <template #item.coloursSideAMax="{item}">
                                                    <v-text-field
                                                        v-model.number="item.coloursSideAMax"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.coloursSideBMax="{item}">
                                                    <v-text-field
                                                        v-model.number="item.coloursSideBMax"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.coloursSideAMin="{item}">
                                                    <v-text-field
                                                        v-model.number="item.coloursSideAMin"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.coloursSideBMin="{item}">
                                                    <v-text-field
                                                        v-model.number="item.coloursSideBMin"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.amountPerHour="{item}">
                                                    <v-text-field
                                                        v-model.number="item.amountPerHour"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.metersPerMinutes="{item}">
                                                    <v-text-field
                                                        v-model.number="item.metersPerMinutes"
                                                        v-mask="'######'"
                                                        min="0"
                                                        dense
                                                        outlined
                                                        hide-details
                                                    />
                                                </template>
                                                <template #item.isEPM="{item}">
                                                    <div class="d-flex align-center justify-center">
                                                        <v-checkbox
                                                            v-model="item.isEPM"
                                                            hide-details
                                                            dense
                                                            class="ma-0 pa-0"
                                                        />
                                                    </div>
                                                </template>
                                                <template #item.isB1Format="{item}">
                                                    <div class="d-flex align-center justify-center">
                                                        <v-checkbox
                                                            v-model="item.isB1Format"
                                                            hide-details
                                                            dense
                                                            class="ma-0 pa-0"
                                                        />
                                                    </div>
                                                </template>
                                                <template #item.actions="{item}">
                                                    <v-btn
                                                        icon
                                                        color="error"
                                                        data-sentry-label="Usuń konfigurację druku cyfrowego"
                                                        @click="removeDigitalRow(item)"
                                                    >
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <template #no-data>
                                                    <div class="text-center py-5 grey--text">
                                                        Brak danych. Dodaj konfigurację klikając przycisk poniżej.
                                                    </div>
                                                </template>
                                                <template #footer>
                                                    <div class="pa-3">
                                                        <v-btn
                                                            color="secondary"
                                                            small
                                                            data-sentry-label="Dodaj kolejną konfigurację wydajności procesów dla druku cyfrowego"
                                                            @click="addNewDigitalRow"
                                                        >
                                                            <v-icon left small>
                                                                mdi-plus
                                                            </v-icon>
                                                            Dodaj kolejną konfigurację
                                                        </v-btn>
                                                    </div>
                                                </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-tab-item>
                        <v-tab-item v-if="machineData.efficiencyTypeId === appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId">
                            <CuttingFromRollTab
                                v-model="configurationCuttingFromRoll"
                                :papers="papersList"
                                :validation="$v.configurationCuttingFromRoll"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </template>

                <template v-else>
                    <div class="pa-5">
                        <v-row>
                            <v-col cols="12" class="text-center py-10">
                                <p class="text-h6 grey--text">
                                    Brak zdefiniowanych konfiguracji wydajności dla maszyny
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                </template>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="hasEfficiencyTabs && saving"
                    @click="closeDialog"
                >
                    Anuluj
                </v-btn>
                <v-spacer v-if="hasEfficiencyTabs" />
                <v-btn
                    v-if="hasEfficiencyTabs"
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="saving"
                    :disabled="hasSaveDisabled"
                    @click="saveConfiguration"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { appConfig } from '@/config'
import { mask } from 'vue-the-mask'
import { required, integer, minValue } from 'vuelidate/lib/validators'
import CuttingFromRollTab from './Efficiency/CuttingFromRollTab'

export default {
    name: 'EfficiencyConfigDialog',
    components: { CuttingFromRollTab },
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        machineData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            appConfig,
            dialog: false,
            tab: 0,
            configurationLoading: false,
            configurationPapers: [],
            configurationDigital: [],
            configurationCuttingFromRoll: [],
            papersList: [],
            saving: false,
            uniqueKeyCounter: 0,
            headers: [
                {
                    text: 'Grupa papieru',
                    value: 'paperGroupId',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Początek zakresu gramatury',
                    value: 'papertWeightBegin',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Koniec zakresu gramatury',
                    value: 'papertWeightEnd',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Wydajność na godzinę',
                    value: 'amountPerHour',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Usuń',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                }
            ],
            digitalHeaders: [
                {
                    text: 'Maksymalna ilość kolorów strona A',
                    value: 'coloursSideAMax',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Maksymalna ilość kolorów strona B',
                    value: 'coloursSideBMax',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Minimalna ilość kolorów strona A',
                    value: 'coloursSideAMin',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Minimalna ilość kolorów strona B',
                    value: 'coloursSideBMin',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Wydajność na godzinę (sztuk)',
                    value: 'amountPerHour',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Wydajność na minutę (MB)',
                    value: 'metersPerMinutes',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Czy druk EPM?',
                    value: 'isEPM',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Czy format B1?',
                    value: 'isB1Format',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Usuń',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                }
            ]
        }
    },
    validations() {
        return {
            configurationCuttingFromRoll: {
                noDuplicatePaperIds: this.noDuplicatePaperIds,
                $each: {
                    makeReadyDuration: {
                        required,
                        integer,
                        minValue: minValue(1)
                    },
                    metersPerMinute: {
                        required,
                        integer,
                        minValue: minValue(1)
                    }
                }
            }
        }
    },
    computed: {
        paperGroups() {
            return this.$store.state.configurations.paperGroups.paperGroups
        },
        hasEfficiencyTabs() {
            return [1, 2, appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId].includes(this.machineData.efficiencyTypeId)
        },
        papers() {
            return this.papersList
        },
        hasCuttingFromRollValidationErrors() {
            if (this.machineData.efficiencyTypeId !== appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId) return false
            if (!this.$v.configurationCuttingFromRoll) return false

            return this.$v.configurationCuttingFromRoll.$invalid
        },
        hasSaveDisabled() {
            return this.machineData.efficiencyTypeId === appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId && this.hasCuttingFromRollValidationErrors
        }
    },
    watch: {
        isOpen(val) {
            this.dialog = val
            if (val) {
                this.loadConfiguration()
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('on-close')
            }
        }
    },
    methods: {
        async loadConfiguration() {
            this.configurationLoading = true

            if (this.machineData.efficiencyTypeId === appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId) {
                try {
                    const [papersResponse, configurationsResponse] = await Promise.all([
                        this.$store.dispatch('configurations/getPapers', {
                            paginate: '',
                            query: '?isVisible=true',
                            shouldSavedInStore: false
                        }),
                        this.$store.dispatch('configurations/getRollCuttingFromRollEfficiencyConfigurations', this.machineData.id)
                    ])

                    this.papersList = papersResponse.data.results || []
                    const configurations = configurationsResponse.data.results || []

                    this.configurationCuttingFromRoll = configurations.map(config => ({
                        id: config.id,
                        paperId: config.paperId,
                        makeReadyDuration: config.makeReadyDuration,
                        metersPerMinute: config.metersPerMinute,
                        uniqueKey: config.id || `temp-cutting-from-roll-${this.uniqueKeyCounter++}`
                    }))
                } catch (error) {
                    errorHandler(error)
                } finally {
                    this.configurationLoading = false
                }

                return
            }

            if (!this.machineData.processDurationConfigurationPrintId) {
                this.configurationPapers = []
                this.configurationDigital = []
                this.configurationLoading = false

                return
            }

            try {
                const response = await this.$store.dispatch(
                    'configurations/getProductionProcessDurationConfiguration',
                    this.machineData.processDurationConfigurationPrintId
                )

                const data = response.data

                const paperConfigurations = data.productionProcessDurationConfigurationPapers || []

                this.configurationPapers = paperConfigurations.map(paperConfiguration => ({
                    id: paperConfiguration.id,
                    paperGroupId: paperConfiguration.paperGroupId,
                    papertWeightBegin: paperConfiguration.papertWeightBegin,
                    papertWeightEnd: paperConfiguration.papertWeightEnd,
                    amountPerHour: paperConfiguration.amountPerHour,
                    uniqueKey: paperConfiguration.id || `temp-${this.uniqueKeyCounter++}`
                }))

                const digitalConfigurations = data.productionProcessDurationConfigurationDigital || []

                this.configurationDigital = digitalConfigurations.map(digitalConfiguration => ({
                    id: digitalConfiguration.id,
                    coloursSideAMax: digitalConfiguration.coloursSideAMax,
                    coloursSideBMax: digitalConfiguration.coloursSideBMax,
                    coloursSideAMin: digitalConfiguration.coloursSideAMin,
                    coloursSideBMin: digitalConfiguration.coloursSideBMin,
                    amountPerHour: digitalConfiguration.amountPerHour,
                    metersPerMinutes: digitalConfiguration.metersPerMinutes,
                    isEPM: digitalConfiguration.isEPM,
                    isB1Format: digitalConfiguration.isB1Format,
                    uniqueKey: digitalConfiguration.id || `temp-digital-${this.uniqueKeyCounter++}`
                }))
            } catch (error) {
                errorHandler(error)
            } finally {
                this.configurationLoading = false
            }
        },
        addNewRow() {
            this.configurationPapers.push({
                paperGroupId: null,
                papertWeightBegin: 0,
                papertWeightEnd: 0,
                amountPerHour: 0,
                uniqueKey: `new-${this.uniqueKeyCounter++}`
            })
        },
        addNewDigitalRow() {
            this.configurationDigital.push({
                coloursSideAMax: 0,
                coloursSideBMax: 0,
                coloursSideAMin: 0,
                coloursSideBMin: 0,
                amountPerHour: null,
                metersPerMinutes: null,
                isEPM: false,
                isB1Format: false,
                uniqueKey: `new-digital-${this.uniqueKeyCounter++}`
            })
        },
        removeRow(item) {
            const index = this.configurationPapers.findIndex(paper => paper.uniqueKey === item.uniqueKey)

            if (index !== -1) {
                this.configurationPapers.splice(index, 1)
            }
        },
        removeDigitalRow(item) {
            const index = this.configurationDigital.findIndex(configuration => configuration.uniqueKey === item.uniqueKey)

            if (index !== -1) {
                this.configurationDigital.splice(index, 1)
            }
        },
        noDuplicatePaperIds(items) {
            const ids = (items || []).map(item => item.paperId).filter(paperId => paperId != null)

            return ids.length === new Set(ids).size
        },

        async saveConfiguration() {
            this.saving = true

            if (this.machineData.efficiencyTypeId === appConfig.configurations.machines.efficiencies.cuttingFromRollTypeId) {
                try {
                    const payload = {
                        machineId: this.machineData.id,
                        configurations: this.configurationCuttingFromRoll.map(config => {
                            const item = {
                                machineId: this.machineData.id,
                                paperId: config.paperId,
                                makeReadyDuration: config.makeReadyDuration,
                                metersPerMinute: config.metersPerMinute
                            }

                            if (config.id) item.id = config.id

                            return item
                        })
                    }

                    await this.$store.dispatch('configurations/saveRollCuttingFromRollEfficiencyBulk', payload)

                    this.$emit('on-success')

                    this.closeDialog()
                } catch (error) {
                    errorHandler(error)
                } finally {
                    this.saving = false
                }

                return
            }

            const normalizeOptionalNumber = value => (typeof value === 'number' ? value : null)

            const payload = {
                productionProcessDurationConfigurationPapers: this.configurationPapers.map(paperConfiguration => {
                    const item = {
                        paperGroupId: paperConfiguration.paperGroupId,
                        papertWeightBegin: paperConfiguration.papertWeightBegin,
                        papertWeightEnd: paperConfiguration.papertWeightEnd,
                        amountPerHour: paperConfiguration.amountPerHour
                    }

                    // Only include id if it exists (for updates)
                    if (paperConfiguration.id) {
                        item.id = paperConfiguration.id
                    }

                    return item
                }),
                productionProcessDurationConfigurationDigital: this.configurationDigital.map(digitalConfiguration => {
                    const item = {
                        coloursSideAMax: digitalConfiguration.coloursSideAMax,
                        coloursSideBMax: digitalConfiguration.coloursSideBMax,
                        coloursSideAMin: digitalConfiguration.coloursSideAMin,
                        coloursSideBMin: digitalConfiguration.coloursSideBMin,
                        amountPerHour: normalizeOptionalNumber(digitalConfiguration.amountPerHour),
                        metersPerMinutes: normalizeOptionalNumber(digitalConfiguration.metersPerMinutes),
                        isEPM: digitalConfiguration.isEPM,
                        isB1Format: digitalConfiguration.isB1Format
                    }

                    if (digitalConfiguration.id) {
                        item.id = digitalConfiguration.id
                    }

                    return item
                }),
                machineId: this.machineData.id,
                productionProcessId: appConfig.common.processes.printTaskId
            }

            try {
                if (this.machineData.processDurationConfigurationPrintId) {
                    // update config
                    await this.$store.dispatch('configurations/updateProductionProcessDurationConfiguration', {
                        id: this.machineData.processDurationConfigurationPrintId,
                        data: payload
                    })
                } else {
                    // create config
                    await this.$store.dispatch('configurations/createProductionProcessDurationConfiguration', payload)
                }

                this.$emit('on-success')
                this.closeDialog()
            } catch (error) {
                errorHandler(error)
            } finally {
                this.saving = false
            }
        },
        closeDialog() {
            this.configurationPapers = []
            this.configurationDigital = []
            this.configurationCuttingFromRoll = []
            this.papersList = []
            this.configurationLoading = false
            this.tab = 0
            this.dialog = false
        }
    }
}
</script>
